import { Crown } from "./Logo";

const WORDS = ["Luxury Looks", "Everyday Finds", "Style", "Living", "Everyday Luxe", "More Than a Store", "It's a Lifestyle"];

export const Marquee = () => {
  const row = (
    <div className="flex shrink-0 items-center">
      {WORDS.map((w, i) => (
        <span key={w} className="flex items-center">
          <span className={`px-8 sm:px-12 font-display text-4xl sm:text-6xl lg:text-7xl ${i % 2 ? "italic gold-text" : "text-cream"}`}>{w}</span>
          <Crown className="w-10 h-7 sm:w-14 sm:h-9 opacity-90" />
        </span>
      ))}
    </div>
  );
  return (
    <section data-testid="editorial-marquee" className="relative overflow-hidden bg-plum py-8 sm:py-12 grain" aria-label="Luxe Dream Market values">
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        {row}
        {row}
      </div>
    </section>
  );
};
